import React from 'react';
import {
  Card as ShadcnCard,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/lib/components/ui/card';

const Card = ({ children }: { children: React.ReactNode }) => {
  return <ShadcnCard className="w-full">{children}</ShadcnCard>;
};

const Title = ({ children }: { children: React.ReactNode }) => {
  return <CardTitle className="text-xl">{children}</CardTitle>;
};

const Description = ({ children }: { children: React.ReactNode }) => {
  return <CardDescription>{children}</CardDescription>;
};

const Header = ({ children }: { children: React.ReactNode }) => {
  return <CardHeader className="flex gap-2 flex-col">{children}</CardHeader>;
};

const Body = ({ children }: { children: React.ReactNode }) => {
  return <CardContent className="gap-4 p-6">{children}</CardContent>;
};

const Footer = ({ children }: { children: React.ReactNode }) => {
  return (
    <CardFooter className="justify-end p-2 border-t">{children}</CardFooter>
  );
};

Card.Body = Body;
Card.Title = Title;
Card.Description = Description;
Card.Header = Header;
Card.Footer = Footer;

export default Card;
